'use client';

/**
 * on PromotionBannerError or empty there should explicitly shown nothing.
 *
 * @returns Div
 */
export const PromotionBannerEmpty = () => <div className="container" />;
